import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from './../../../node_modules/@ngx-translate/core';

@Injectable()
export class ToastService {
    constructor( public translate:TranslateService, private messageService: MessageService) {}

    Success(message?: string) {
        this.messageService.add({severity:'success', summary:this.getSummary("LABEL.UPLOAD.SUCCESS_MSG"), detail: message, life:5000});
    }

    Warning(message?: string) {
        this.messageService.add({severity:'warn', summary:this.getSummary("LABEL.UPLOAD.WARNING_MSG"), detail: message, life:5000});
    }

    Error(message?: string) {
        this.messageService.add({severity:'error', summary:this.getSummary("LABEL.UPLOAD.ERROR_MSG"), detail: message, life:5000});
    }

    Info(message?: string) {
        this.messageService.add({severity:'info', summary:this.getSummary("LABEL.UPLOAD.INFO_MSG"), detail: message, life:5000});
    }


    getSummary(key:string) : string {
        let summary: string;
        this.translate.get(key).subscribe((value) => {
            summary = value;
            });
            return summary;
    }

}